var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('Dialog', {
    attrs: {
      "title": "Edit Experiment",
      "show": _vm.isOpen,
      "onClose": _vm.onClose
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.item,
      "label-width": "140px",
      "label-position": "left",
      "size": "small"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Name",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": !!_vm.item.id
    },
    model: {
      value: _vm.item.name,
      callback: function ($$v) {
        _vm.$set(_vm.item, "name", $$v);
      },
      expression: "item.name"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "Description"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: _vm.item.description,
      callback: function ($$v) {
        _vm.$set(_vm.item, "description", $$v);
      },
      expression: "item.description"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "Period (days)"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "min": 0
    },
    model: {
      value: _vm.item.period,
      callback: function ($$v) {
        _vm.$set(_vm.item, "period", $$v);
      },
      expression: "item.period"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "Active"
    }
  }, [_c('el-radio-group', {
    model: {
      value: _vm.item.is_active,
      callback: function ($$v) {
        _vm.$set(_vm.item, "is_active", $$v);
      },
      expression: "item.is_active"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": true,
      "disabled": ""
    }
  }, [_vm._v("Yes")]), _c('el-radio', {
    attrs: {
      "label": false,
      "disabled": ""
    }
  }, [_vm._v("No")])], 1), _c('div', [_vm._v("Toggle via Deploy / End buttons on the main table.")])], 1), _c('el-form-item', {
    attrs: {
      "label": "Type",
      "required": ""
    }
  }, [_c('el-radio-group', {
    model: {
      value: _vm.item.experiment_type,
      callback: function ($$v) {
        _vm.$set(_vm.item, "experiment_type", $$v);
      },
      expression: "item.experiment_type"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "ab"
    }
  }, [_vm._v("A/B")]), _c('el-radio', {
    attrs: {
      "label": "variants"
    }
  }, [_vm._v("Variants")]), _c('el-radio', {
    attrs: {
      "label": "feature_toggle"
    }
  }, [_vm._v("Feature toggle")])], 1)], 1), _vm.isABTest ? _c('div', [_c('el-form-item', {
    attrs: {
      "label": "Traffic (0-1)",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "min": 0,
      "max": 1,
      "step": 0.1
    },
    model: {
      value: _vm.item.traffic,
      callback: function ($$v) {
        _vm.$set(_vm.item, "traffic", $$v);
      },
      expression: "item.traffic"
    }
  })], 1)], 1) : _vm.isVariants ? _c('div', [_c('div', {
    staticClass: "title"
  }, [_c('h3', [_vm._v("Variants")])]), _vm._l(_vm.item.variants, function (v, index) {
    return _c('el-form-item', {
      key: index,
      attrs: {
        "label": `Variant ${index + 1}`
      }
    }, [_c('el-form', {
      attrs: {
        "inline": "",
        "size": "mini",
        "label-position": "top"
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "Name"
      }
    }, [_c('el-input', {
      attrs: {
        "readonly": !v.isNew
      },
      model: {
        value: v.value,
        callback: function ($$v) {
          _vm.$set(v, "value", $$v);
        },
        expression: "v.value"
      }
    })], 1), _c('el-form-item', {
      staticStyle: {
        "width": "160px"
      },
      attrs: {
        "label": "Traffic (0-1)"
      }
    }, [_c('el-input', {
      attrs: {
        "type": "number",
        "min": 0,
        "max": 1,
        "step": 0.1
      },
      model: {
        value: v.traffic,
        callback: function ($$v) {
          _vm.$set(v, "traffic", $$v);
        },
        expression: "v.traffic"
      }
    })], 1), v.isNew ? _c('el-form-item', {
      attrs: {
        "label": "Remove"
      }
    }, [_c('el-link', {
      attrs: {
        "type": "danger"
      },
      on: {
        "click": function ($event) {
          return _vm.removeVariant(index);
        }
      }
    }, [_vm._v("Remove")])], 1) : _vm._e()], 1)], 1);
  }), _c('el-form-item', {
    attrs: {
      "label": `Variant ${_vm.item.variants.length + 1}`
    }
  }, [_c('el-form', {
    attrs: {
      "inline": "",
      "size": "mini",
      "label-position": "top"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Name"
    }
  }, [_c('el-input', {
    model: {
      value: _vm.variant.value,
      callback: function ($$v) {
        _vm.$set(_vm.variant, "value", $$v);
      },
      expression: "variant.value"
    }
  })], 1), _c('el-form-item', {
    staticStyle: {
      "width": "160px"
    },
    attrs: {
      "label": "Traffic (0-1)"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "min": 0,
      "max": 1,
      "step": 0.1
    },
    model: {
      value: _vm.variant.traffic,
      callback: function ($$v) {
        _vm.$set(_vm.variant, "traffic", $$v);
      },
      expression: "variant.traffic"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "Add"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addVariant
    }
  }, [_vm._v("Add")])], 1)], 1)], 1)], 2) : _vm.isFeatureToggle ? _c('div', [_c('el-form-item', {
    attrs: {
      "label": "Feature on/off",
      "required": ""
    }
  }, [_c('el-switch', {
    attrs: {
      "active-text": "On",
      "inactive-text": "Off"
    },
    model: {
      value: _vm.ftValue,
      callback: function ($$v) {
        _vm.ftValue = $$v;
      },
      expression: "ftValue"
    }
  })], 1)], 1) : _vm._e(), !_vm.isFeatureToggle ? _c('el-form-item', {
    attrs: {
      "label": "New users only?"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-text": "Yes",
      "inactive-text": "No"
    },
    model: {
      value: _vm.item.is_for_new_users,
      callback: function ($$v) {
        _vm.$set(_vm.item, "is_for_new_users", $$v);
      },
      expression: "item.is_for_new_users"
    }
  })], 1) : _vm._e(), !_vm.isFeatureToggle ? _c('el-form-item', {
    attrs: {
      "label": "Segment"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "loading": _vm.loading.cohorts,
      "placeholder": "Filter by Cohort name..."
    },
    model: {
      value: _vm.item.cohort_id,
      callback: function ($$v) {
        _vm.$set(_vm.item, "cohort_id", $$v);
      },
      expression: "item.cohort_id"
    }
  }, _vm._l(_vm.cohorts, function (cohort) {
    return _c('el-option', {
      key: cohort.id,
      attrs: {
        "value": cohort.id,
        "label": cohort.name
      }
    });
  }), 1)], 1) : _vm._e(), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v(_vm._s(_vm.item.id ? "Save" : "Create"))]), _c('el-button', {
    on: {
      "click": function ($event) {
        return _vm.onClose();
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }